import classes from "./StekList.module.scss"
import Cards from '../../../Cards/Cards';

import img1 from "../../../Assets/Img/Src/Stek/1.png"
import img1Webp from "../../../Assets/Img/Webp/Stek/1.webp"
//<------------------------------------------------------------
import img2 from "../../../Assets/Img/Src/Stek/2.png"
import img2Webp from "../../../Assets/Img/Webp/Stek/2.webp"
//<------------------------------------------------------------
import img3 from "../../../Assets/Img/Src/Stek/3.png"
import img3Webp from "../../../Assets/Img/Webp/Stek/3.webp"
//<------------------------------------------------------------
import img4 from "../../../Assets/Img/Src/Stek/4.png"
import img4Webp from "../../../Assets/Img/Webp/Stek/4.webp"
//<------------------------------------------------------------
import img5 from "../../../Assets/Img/Src/Stek/5.png"
import img5Webp from "../../../Assets/Img/Webp/Stek/5.webp"
//<------------------------------------------------------------
import img6 from "../../../Assets/Img/Src/Stek/6.png"
import img6Webp from "../../../Assets/Img/Webp/Stek/6.webp"
//<------------------------------------------------------------
import img7 from "../../../Assets/Img/Src/Stek/7.png"
import img7Webp from "../../../Assets/Img/Webp/Stek/7.webp"
//<------------------------------------------------------------
import img8 from "../../../Assets/Img/Src/Stek/8.png"
import img8Webp from "../../../Assets/Img/Webp/Stek/8.webp"
//<------------------------------------------------------------
import img9 from "../../../Assets/Img/Src/Stek/9.png"
import img9Webp from "../../../Assets/Img/Webp/Stek/9.webp"
//<------------------------------------------------------------
import img10 from "../../../Assets/Img/Src/Stek/10.png"
import img10Webp from "../../../Assets/Img/Webp/Stek/10.webp"
//<------------------------------------------------------------
import img11 from "../../../Assets/Img/Src/Stek/11.png"
import img11Webp from "../../../Assets/Img/Webp/Stek/11.webp"
//<------------------------------------------------------------
import img12 from "../../../Assets/Img/Src/Stek/12.png"
import img12Webp from "../../../Assets/Img/Webp/Stek/12.webp"
//<------------------------------------------------------------
import img13 from "../../../Assets/Img/Src/Stek/13.png"
import img13Webp from "../../../Assets/Img/Webp/Stek/13.webp"
//<------------------------------------------------------------
import img14 from "../../../Assets/Img/Src/Stek/14.png"
import img14Webp from "../../../Assets/Img/Webp/Stek/14.webp"
//<------------------------------------------------------------


const Data = [
  {
    number: "Screaming Frog",
    src: img1,
    srcWebp: img1Webp,
  },
  {
    number: "Яндекс Метрика",
    src: img2,
    srcWebp: img2Webp,
  },
  {
    number: "Google Analytics",
    src: img3,
    srcWebp: img3Webp,
  },
  {
    number: "Spy Words",
    src: img4,
    srcWebp: img4Webp,
  },
  {
    number: "All Positions",
    src: img5,
    srcWebp: img5Webp,
  },
  {
    number: "Key Collector",
    src: img6,
    srcWebp: img6Webp,
  },
  {
    number: "Bitrix 24",
    src: img7,
    srcWebp: img7Webp,
  },
  {
    number: "Google Sheets",
    src: img8,
    srcWebp: img8Webp,
  },
  {
    number: "Yandex Webmaster",
    src: img9,
    srcWebp: img9Webp,
  },
  {
    number: "Google Search Console",
    src: img10,
    srcWebp: img10Webp,
  },
  {
    number: "Ahrefs",
    src: img11,
    srcWebp: img11Webp,
  },
  {
    number: "CallTouch",
    src: img12,
    srcWebp: img12Webp,
  },
  {
    number: "LinkPad",
    src: img13,
    srcWebp: img13Webp,
  },
  {
    number: "ChekMy",
    src: img14,
    srcWebp: img14Webp,
  },
];

const StekList = ()=> {
  return (
    <div className={classes.List}>
      {Data.map( (item, index) => {
        return <Cards 
          src={item.src}
          srcWebp={item.srcWebp}
          key={index}
          number={item.number}
          customClass={classes.Cards}
          customNumClass={classes.Number}
            />
      })}
    </div>
  )
}



export default StekList;